import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import {
  httpGetShoppingCartGet,
  httpPostShoppingCartIncrementQuantity,
  httpPostShoppingCartSetQuantity,
  ShoppingCartIncrementDto,
  ShoppingCartItemDto,
} from '@zvoove-market/api';
import { ReplaySubject } from 'rxjs';
import { map, tap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class ShoppingCartService {
  private http = inject(HttpClient);
  private _items$ = new ReplaySubject<ShoppingCartItemDto[]>(1);
  private _initialized = false;

  public get items$() {
    if (!this._initialized) {
      this.refresh().subscribe();
    }
    return this._items$.asObservable();
  }

  public get itemCount$() {
    if (!this._initialized) {
      this.refresh().subscribe();
    }
    return this._items$.pipe(map((items) => items.reduce((partialSum, item) => partialSum + item.quantity, 0)));
  }

  public refresh() {
    this._initialized = true;
    return httpGetShoppingCartGet(this.http).pipe(tap((cart) => this._items$.next(cart)));
  }

  public incrementQuantity(item: ShoppingCartIncrementDto) {
    this._initialized = true;
    return httpPostShoppingCartIncrementQuantity(this.http, { body: item }).pipe(tap((cart) => this._items$.next(cart)));
  }

  public setQuantity(item: ShoppingCartIncrementDto) {
    this._initialized = true;
    return httpPostShoppingCartSetQuantity(this.http, { body: item }).pipe(tap((cart) => this._items$.next(cart)));
  }

  public remove(productCode: string) {
    this._initialized = true;
    return httpPostShoppingCartSetQuantity(this.http, { body: { productCode: productCode, quantity: 0 } }).pipe(
      tap((cart) => this._items$.next(cart))
    );
  }
}
